import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import SelectAsync from 'react-select/async';

export default class PaySlip extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true,
            controllerName: 'payslip',
            employmentOrders: [],
            timeSheets: [],
            timeSheetHeaders: [],
            systemModuleId: 3,
            moduleAccessStatus: 1,
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.getData();
            });
    }
    getData() {
        this.httpPost("api/v1/payslip/get", {
            id: this.getCurrentFormId(),
        })
            .then(async data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 0) {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
                else {
                    window.companyId = data.global.company.id;
                    this.state.data = data;
                    if (this.getCurrentFormId() != this.getDefaultGuid())
                        await this.getLastEmploymentOrderRequest(data.record.manCompanyId);
                    else {
                        this.setState({
                            loading: false
                        });
                    }
                }
            });
    }
    loadManCompaniesOptions(inputValue, callback) {
        var companyId = window.companyId;
        setTimeout(() => {
            fetch("/api/v1/common/getmancompanies/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    companyId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name + "(" + _record.nationalId + ")",
                            registerDate: _record.registerDate,
                            childrenCount: _record.childrenCount
                        }));
                    }
                    callback(items);
                })
        }, 50);
    }
    save(e) {
        e.preventDefault();
        if (this.isBlank(this.state.data.record.year)) this.state.data.record.year = 0;
        if (this.isBlank(this.state.data.record.month)) this.state.data.record.month = 0;
        if (this.isBlank(this.state.data.record.day)) this.state.data.record.day = 0;
        if (this.isBlank(this.state.data.record.hour)) this.state.data.record.hour = 0;
        if (this.isBlank(this.state.data.record.extraTime)) this.state.data.record.extraTime = 0;
        if (this.isBlank(this.state.data.record.night)) this.state.data.record.night = 0;
        if (this.isBlank(this.state.data.record.jazb)) this.state.data.record.jazb = 0;
        if (this.isBlank(this.state.data.record.masoliyat)) this.state.data.record.masoliyat = 0;
        if (this.isBlank(this.state.data.record.leaveDay)) this.state.data.record.leaveDay = 0;
        if (this.isBlank(this.state.data.record.leaveHour)) this.state.data.record.leaveHour = 0;
        if (this.isBlank(this.state.data.record.mosaede)) this.state.data.record.mosaede = 0;
        if (this.isBlank(this.state.data.record.vam)) this.state.data.record.vam = 0;
        if (this.isBlank(this.state.data.record.other)) this.state.data.record.other = 0;
        if (this.isBlank(this.state.data.record.mamoriyat)) this.state.data.record.mamoriyat = 0;
        if (this.isBlank(this.state.data.record.childrenCount)) this.state.data.record.childrenCount = 0;
        if (this.isBlank(this.state.data.record.monthLeave)) this.state.data.record.monthLeave = 0
        if (this.isBlank(this.state.data.record.monthLeaveDay)) this.state.data.record.monthLeaveDay = 0;

        if (this.isBlank(this.state.data.record.holyDay)) this.state.data.record.holyDay = 0;
        if (this.isBlank(this.state.data.record.friDay)) this.state.data.record.friDay = 0;
        if (this.isBlank(this.state.data.record.zMamoriyat)) this.state.data.record.zMamoriyat = 0;
        if (this.isBlank(this.state.data.record.zMamoriyat)) this.state.data.record.zMamoriyat = 0;
        if (this.isBlank(this.state.data.record.zNight)) this.state.data.record.zNight = 0;
        if (this.isBlank(this.state.data.record.zFriday)) this.state.data.record.zFriday = 0;
        if (this.isBlank(this.state.data.record.zHoliday)) this.state.data.record.zHoliday = 0;

        if (this.isBlank(this.state.data.record.reward)) this.state.data.record.reward = 0;
        if (this.isBlank(this.state.data.record.leaveRemainDay)) this.state.data.record.leaveRemainDay = 0;
        if (this.isBlank(this.state.data.record.leaveRemainHour)) this.state.data.record.leaveRemainHour = 0;

        if (this.isBlank(this.state.data.record.bMonthBase)) this.state.data.record.bMonthBase = 0;
        if (this.isBlank(this.state.data.record.bKharobar)) this.state.data.record.bKharobar = 0;
        if (this.isBlank(this.state.data.record.bMaskan)) this.state.data.record.bMaskan = 0;
        if (this.isBlank(this.state.data.record.bMariage)) this.state.data.record.bMariage = 0;
        
        if (this.isBlank(this.state.data.record.bOlad)) this.state.data.record.bOlad = 0;
        if (this.isBlank(this.state.data.record.bExtraWork)) this.state.data.record.bExtraWork = 0;
        if (this.isBlank(this.state.data.record.zExtraWork)) this.state.data.record.zExtraWork = 0;
        if (this.isBlank(this.state.data.record.bNight)) this.state.data.record.bNight = 0;
        if (this.isBlank(this.state.data.record.bHolyDay)) this.state.data.record.bHolyDay = 0;
        if (this.isBlank(this.state.data.record.bFriday)) this.state.data.record.bFriday = 0;
        if (this.isBlank(this.state.data.record.bNobat)) this.state.data.record.bNobat = 0;
        if (this.isBlank(this.state.data.record.bMamoriyat)) this.state.data.record.bMamoriyat = 0;

        if (this.isBlank(this.state.data.record.total)) this.state.data.record.total = 0;
        if (this.isBlank(this.state.data.record.totalWithTax)) this.state.data.record.totalWithTax = 0;
        if (this.isBlank(this.state.data.record.totalWithInsu)) this.state.data.record.totalWithInsu = 0;
        if (this.isBlank(this.state.data.record.tamin1)) this.state.data.record.tamin1 = 0;
        if (this.isBlank(this.state.data.record.tamin2)) this.state.data.record.tamin2 = 0;
        if (this.isBlank(this.state.data.record.orgDeductions)) this.state.data.record.orgDeductions = 0;
        if (this.isBlank(this.state.data.record.legalDeductions)) this.state.data.record.legalDeductions = 0;
        if (this.isBlank(this.state.data.record.final)) this.state.data.record.final = 0;

        if (this.isBlank(this.state.data.record.bHourSalary2)) this.state.data.record.bHourSalary2 = 0;
        if (this.isBlank(this.state.data.record.bDaySalary)) this.state.data.record.bDaySalary = 0;
        if (this.isBlank(this.state.data.record.bDaySalary2)) this.state.data.record.bDaySalary2 = 0;
        if (this.isBlank(this.state.data.record.bMonthBase2)) this.state.data.record.bMonthBase2 = 0;

        if (this.isBlank(this.state.data.record.kosoratMosaede)) this.state.data.record.kosoratMosaede = 0;
        if (this.isBlank(this.state.data.record.kosoratVam)) this.state.data.record.kosoratVam = 0;
        if (this.isBlank(this.state.data.record.kosoratOther)) this.state.data.record.kosoratOther = 0;
        if (this.isBlank(this.state.data.record.kosoratGeybat)) this.state.data.record.kosoratGeybat = 0;
        if (this.isBlank(this.state.data.record.kosoratTamin)) this.state.data.record.kosoratTamin = 0;
        if (this.isBlank(this.state.data.record.kosoratBime)) this.state.data.record.kosoratBime = 0;
        if (this.isBlank(this.state.data.record.kosoratMoafiyat)) this.state.data.record.kosoratMoafiyat = 0;
        if (this.isBlank(this.state.data.record.kosoratTax)) this.state.data.record.kosoratTax = 0;

        if (this.isBlank(this.state.data.record.employeeYear)) this.state.data.record.employeeYear = 0;

        if (this.isBlank(this.state.data.record.monthDays)) this.state.data.record.monthDays = 0;

        if (this.isBlank(this.state.data.record.travel)) this.state.data.record.travel = 0;
        if (this.isBlank(this.state.data.record.kamKariTime)) this.state.data.record.kamKariTime = 0;

        this.httpPost("api/v1/payslip/save", {
            id: this.getCurrentFormId(),
            companyId: this.state.data.global.company.id,
            contractId: this.state.data.record.contractId,
            timeSheetHeaderId: this.state.data.record.timeSheetHeaderId,
            employmentOrderId: this.state.data.record.employmentOrderId,
            manCompanyId: this.state.data.record.manCompanyId,
            employeeYear: parseInt(this.state.data.record.employeeYear),
            year: parseInt(this.state.data.record.year),
            month: parseInt(this.state.data.record.month),
            day: parseInt(this.state.data.record.day),
            hour: parseInt(this.state.data.record.hour),
            extraTime: parseInt(this.state.data.record.extraTime),
            night: parseInt(this.state.data.record.night),
            jazb: parseInt(this.state.data.record.jazb),
            masoliyat: parseInt(this.state.data.record.masoliyat),
            leaveDay: parseInt(this.state.data.record.leaveDay),
            leaveHour: parseInt(this.state.data.record.leaveHour),
            mosaede: parseInt(this.state.data.record.mosaede),
            vam: parseInt(this.state.data.record.vam),
            other: parseInt(this.state.data.record.other),
            mamoriyat: parseInt(this.state.data.record.mamoriyat),
            childrenCount: parseInt(this.state.data.record.childrenCount),
            monthLeave: parseFloat(this.state.data.record.monthLeave),
            monthLeaveDay: parseFloat(this.state.data.record.monthLeaveDay),

            shift: parseInt(this.state.data.record.shift),
            extraTimeBase: parseInt(this.state.data.record.extraTimeBase),
            timeBase: parseInt(this.state.data.record.timeBase),
            karkard: parseInt(this.state.data.record.karkard),

            holyDay: parseInt(this.state.data.record.holyDay),
            friDay: parseInt(this.state.data.record.friDay),
            zMamoriyat: parseInt(this.state.data.record.zMamoriyat),
            monthHour: parseInt(this.state.data.record.monthHour),
            zNight: parseInt(this.state.data.record.zNight),
            zFriday: parseInt(this.state.data.record.zFriday),
            zHoliday: parseInt(this.state.data.record.zHoliday),

            reward: parseInt(this.state.data.record.reward),
            leaveRemainDay: parseInt(this.state.data.record.leaveRemainDay),
            leaveRemainHour: parseInt(this.state.data.record.leaveRemainHour),

            bMonthBase: parseInt(this.state.data.record.bMonthBase),
            bKharobar: parseInt(this.state.data.record.bKharobar),
            bMaskan: parseInt(this.state.data.record.bMaskan),
            bMariage: parseInt(this.state.data.record.bMariage),
            
            bOlad: parseInt(this.state.data.record.bOlad),
            bExtraWork: parseInt(this.state.data.record.bExtraWork),
            zExtraWork: parseInt(this.state.data.record.bExtraWork),
            bNight: parseInt(this.state.data.record.bNight),
            bHolyDay: parseInt(this.state.data.record.bHolyDay),
            bFriday: parseInt(this.state.data.record.bFriday),
            bNobat: parseInt(this.state.data.record.bNobat),
            bMamoriyat: parseInt(this.state.data.record.bMamoriyat),

            total: parseInt(this.state.data.record.total),
            totalWithTax: parseInt(this.state.data.record.totalWithTax),
            totalWithInsu: parseInt(this.state.data.record.totalWithInsu),
            tamin1: parseInt(this.state.data.record.tamin1),
            tamin2: parseInt(this.state.data.record.tamin2),
            orgDeductions: parseInt(this.state.data.record.orgDeductions),
            legalDeductions: parseInt(this.state.data.record.legalDeductions),
            final: parseInt(this.state.data.record.final),

            bHourSalary2: parseInt(this.state.data.record.bHourSalary2),
            bDaySalary: parseInt(this.state.data.record.bDaySalary),
            bDaySalary2: parseInt(this.state.data.record.bDaySalary2),
            bMonthBase2: parseInt(this.state.data.record.bMonthBase2),

            kosoratMosaede: parseInt(this.state.data.record.kosoratMosaede),
            kosoratVam: parseInt(this.state.data.record.kosoratVam),
            kosoratOther: parseInt(this.state.data.record.kosoratOther),
            kosoratGeybat: parseInt(this.state.data.record.kosoratGeybat),
            kosoratTamin: parseInt(this.state.data.record.kosoratTamin),
            kosoratBime: parseInt(this.state.data.record.kosoratBime),
            kosoratMoafiyat: parseInt(this.state.data.record.kosoratMoafiyat),
            kosoratTax: parseInt(this.state.data.record.kosoratTax),

            moafiyatMah: parseInt(this.state.data.record.moafiyatMah),
            maliyatMah: parseInt(this.state.data.record.maliyatMah),
            hogogMashmolMaliyatTajmiyi: parseInt(this.state.data.record.hogogMashmolMaliyatTajmiyi),
            moafiyatTajmiyiMah: parseInt(this.state.data.record.moafiyatTajmiyiMah),
            maliyatMahTajmiyi: parseInt(this.state.data.record.maliyatMahTajmiyi),

            monthDays: parseInt(this.state.data.record.monthDays),

            travel: parseInt(this.state.data.record.travel),
            kamKariTime: parseInt(this.state.data.record.kamKariTime),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/payslips/'
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setPersonType(v, e) {
        this.state.data.record.type = v;
        this.setState({ data: this.state.data });
    }
    async itemChange(f, e) {

        if (f == "manCompanyId") {
            this.state.data.record[f] = e.value;
            if (e.registerDate.includes("-")) this.state.data.record.employeeYear = parseInt(e.registerDate.split("-")[0]);
            if (e.registerDate.includes("/")) this.state.data.record.employeeYear = parseInt(e.registerDate.split("-")[0]);
            this.state.data.record.childrenCount = e.childrenCount;
        }
        else {
            if (f == 'employmentOrderId' || f == 'timeSheetHeaderId') {
                this.state.data.record[f] = e;
            }
            else {
                this.state.data.record[f] = parseInt(e);
            }
        }
        if (f == 'year') {
            this.state.data.record.employmentOrderId = this.getDefaultGuid();
            this.state.data.record.timeSheetHeaderId = this.getDefaultGuid();
            this.state.data.record.contractId = 0;
        }
        if (f == 'employmentOrderId') {
            this.state.data.record.timeSheetHeaderId = this.getDefaultGuid();
            this.state.data.record.contractId = 0;
            this.state.employmentOrders.forEach(em => {

                if (em.id == this.state.data.record.employmentOrderId) this.state.data.record.contractId = em.contractId;
            });
        }
        if (f == 'manCompanyId')
            await this.getLastEmploymentOrder(this.state.data.record.manCompanyId);

        if (f == 'leaveDay') this.state.data.record.leaveHour = this.FixedPointNumber(this.state.data.record.leaveDay * 7.33, 2);
        if (f == 'leaveHour') this.state.data.record.leaveDay = this.FixedPointNumber(this.state.data.record.leaveHour / 7.33, 2);

        if (f == 'month') {
            if (this.state.data.record.month <= 6) this.state.data.record.monthDays = 31;
            if (this.state.data.record.month > 6 && this.state.data.record.month < 12) this.state.data.record.monthDays = 30;
            if (this.state.data.record.month == 12) this.state.data.record.monthDays = 29;
        }

        if (f == 'manCompanyId' || f == 'year' || f == 'month' || f == 'childrenCount' || f == 'employeeYear') this.syncAnuualSttings();
        if (f == 'employmentOrderId' || f == 'timeSheetHeaderId') this.updateEmploymentOrder();

        this.updateFormula();

        this.setState({ data: this.state.data });
    }
    getLastEmploymentOrder(manCompanyId) {
        this.state.data.record.zMamoriyat = 0;
        this.state.data.record.zExtraWork = 0;
        this.state.data.record.jazb = 0;
        this.state.data.record.masoliyat = 0;
        this.state.data.record.karkard = 0;
        this.state.data.record.shift = 0;
        this.state.data.record.extraTimeBase = 174;
        this.state.data.record.timeBase = 174;
        this.state.data.record.employmentOrderId = this.getDefaultGuid();
        this.state.data.record.timeSheetHeaderId = this.getDefaultGuid();
        this.state.data.record.contractId = 0;
        this.state.employmentOrders = [];
        this.state.timeSheets = [];
        this.state.timeSheetHeaders = [];

        return this.getLastEmploymentOrderRequest(manCompanyId);
    }
    getLastEmploymentOrderRequest(manCompanyId) {
        return new Promise((resolve, reject) => {
            this.httpPost("api/v1/employmentorder/last", {
                manCompanyId
            })
                .then(data => {
                    if (data.status === -1) window.location.href = "/login";
                    if (data.status === 0) {
                        this.showErorrMessage(data.message);
                        this.setState({
                            loading: false
                        });
                    }
                    else {
                        if (this.isEmpty(data.records)) {
                            this.showErorrMessage("توجه. حکم کارگزینی ایشان صادر نشده است");
                            resolve(true);
                            return;
                        }
                        this.state.employmentOrders = data.records;;
                        this.state.timeSheets = data.timeSheets;
                        this.state.timeSheetHeaders = data.timeSheetHeaders;

                        this.setState({
                            loading: false
                        })
                    }
                    resolve(true);
                });
        })
    }
    //محاسبه حقوق تصاعدی بر اساس سال استخدام و سال صدور فیش
    syncAnuualSttings() {
        //this.state.data.record.bDaySalary = 0;
        // this.state.data.record.bDaySalary2 = 0;
        this.state.data.record.monthHour = 0;
        this.state.data.record.bMonthBase = 0;
        this.state.data.record.bKharobar = 0;
        this.state.data.record.bMaskan = 0;
        this.state.data.record.bMariage = 0;        
        this.state.data.record.bOlad = 0;
        this.state.data.record.monthLeave = 0;
        this.state.data.record.monthLeaveDay = 0;

        if (this.state.data.record.manCompanyId <= 0) return;

        var salaryBase = null;
        this.state.data.salaryBases.forEach(f => {
            if (f.year == this.state.data.record.year) salaryBase = f;
        });

        var totalHour = 0;
        this.state.data.salaryMonthSettings.forEach(f => {
            if (f.year == this.state.data.record.year && f.month == this.state.data.record.month) this.state.data.record.monthHour = f.hour;
            if (f.year == this.state.data.record.year) totalHour += parseInt(f.hour);
        });

        this.state.data.record.monthLeave = this.FixedPointNumber((this.state.data.record.monthHour * (30 * 7.33)) / totalHour, 7);
        this.state.data.record.monthLeaveDay = this.FixedPointNumber(this.state.data.record.monthLeave / 7.33, 7);

        this.state.data.record.moafiyatMah = 0;
        if (!this.isNull(salaryBase)) {
            this.state.data.record.moafiyatMah = salaryBase.taxExemption;
            this.state.data.record.bKharobar = salaryBase.kharobar;
            this.state.data.record.bMaskan = salaryBase.maskan;
            this.state.data.record.bMariage = salaryBase.mariage;            
            this.state.data.record.bOlad = this.FixedPointNumber(salaryBase.olad * this.state.data.record.childrenCount, 0);
        }

        //this.state.data.escalations.forEach(es => {
        //    if (es.salaryYear == this.state.data.record.year && es.employeeYear == this.state.data.record.year) this.state.data.record.bDaySalary = es.price;
        //    if (es.salaryYear == this.state.data.record.year && es.employeeYear == this.state.data.record.employeeYear) this.state.data.record.bDaySalary2 = es.price;
        //});
    }
    updateEmploymentOrder() {
        this.state.data.record.bDaySalary = 0;
        this.state.data.record.bDaySalary2 = 0;

        this.state.data.record.day = 0;
        this.state.data.record.hour = 0;
        this.state.data.record.night = 0;
        this.state.data.record.holyDay = 0;
        this.state.data.record.friDay = 0;
        this.state.data.record.mamoriyat = 0;

        this.state.data.record.zNight = 0;
        this.state.data.record.zFriday = 0;
        this.state.data.record.zHoliday = 0;
        this.state.data.record.zMamoriyat = 0;
        this.state.data.record.zExtraWork = 0;
        this.state.data.record.jazb = 0;
        this.state.data.record.masoliyat = 0;

        this.state.data.record.karkard = 0;
        this.state.data.record.shift = 0;

        this.state.data.record.extraTimeBase = 0;
        this.state.data.record.timeBase = 0;

        this.state.data.record.bNobat = 0;

        var employmentOrder = null;
        this.state.employmentOrders.forEach(emp => {
            if (emp.id == this.state.data.record.employmentOrderId) employmentOrder = emp;
        });
        if (this.isNull(employmentOrder)) return;
        this.state.data.record.bDaySalary = employmentOrder.contractF1;
        this.state.data.record.bDaySalary2 = employmentOrder.contractF1;

        this.state.data.record.zNight = employmentOrder.nightPercent;
        this.state.data.record.zFriday = employmentOrder.fridayPercent;
        this.state.data.record.zHoliday = employmentOrder.holidayPercent;
        this.state.data.record.zMamoriyat = employmentOrder.taskExtraPercent;
        this.state.data.record.zExtraWork = employmentOrder.extraWorkPercent;
        this.state.data.record.jazb = employmentOrder.contractJazbPrice;
        this.state.data.record.masoliyat = employmentOrder.contractResponsePrice;

        this.state.data.record.karkard = employmentOrder.karkard;
        this.state.data.record.shift = employmentOrder.nobatPercent ? 1 : 0;

        this.state.data.record.extraTimeBase = employmentOrder.mabna;
        this.state.data.record.timeBase = employmentOrder.mabna;

        var timeSheetHeader = null;
        this.state.timeSheetHeaders.forEach(tm => {
            if (tm.id == this.state.data.record.timeSheetHeaderId) timeSheetHeader = tm;
        });
        if (this.isNull(timeSheetHeader)) return;

        var totalDurations = 0;
        var totalNights = 0;
        var totalHoliday = 0;
        var totalFriday = 0;
        var totalMamoriyat = 0;
        var totalDays = 0;
        var totalNobat = 0;
        var days = [];

        this.state.timeSheets.forEach(tm => {
            if (tm.timeSheetHeaderId == timeSheetHeader.id) {
                var isNewDay = true;
                days.forEach(d => {
                    if (d == tm.day) isNewDay = false;
                });
                if (isNewDay) days.push(tm.day);

                totalDurations += tm.duration;
                totalNights += tm.nightTime;
                totalHoliday += tm.holidayTime;
                totalFriday += tm.fridayTime;
                totalMamoriyat += tm.mamoriyatTime;
                totalNobat += tm.nobatTime;
            }
        });
        totalDays = days.length;

        this.state.data.record.day = totalDays;
        this.state.data.record.hour = this.FixedPointNumber(totalDurations / 60, 2);
        this.state.data.record.night = this.FixedPointNumber(totalNights / 60, 2);
        this.state.data.record.holyDay = this.FixedPointNumber(totalHoliday / 60, 2);
        this.state.data.record.friDay = this.FixedPointNumber(totalFriday / 60, 2);
        this.state.data.record.mamoriyat = this.FixedPointNumber(totalMamoriyat / 60, 2);

        //مجموع فوق العاده ها که در محاسبه درصد های پایین کاربرد دارد
        //مقادیر روزانه فوق العاده ها ضربدر تعداد روز + 
        var sumFog = employmentOrder.contractF1 + employmentOrder.contractResponsePrice + employmentOrder.contractJazbPrice + employmentOrder.contractHardWorkPrice + employmentOrder.contractJobPrice + employmentOrder.contractWorkShopPrice + employmentOrder.contractOtherPrice;

        if (employmentOrder.nobatPercent) {
            var percent = 0;
            if (timeSheetHeader.nobat === 1) percent = (employmentOrder.nobatF1 / 100);
            if (timeSheetHeader.nobat === 2) percent = (employmentOrder.nobatF1 / 100);
            if (timeSheetHeader.nobat === 3) percent = (employmentOrder.nobatF1 / 100);
            if (timeSheetHeader.nobat === 4) percent = (employmentOrder.nobatF3 / 100);
            if (timeSheetHeader.nobat === 5) percent = (employmentOrder.nobatF4 / 100);
            if (timeSheetHeader.nobat === 6) percent = (employmentOrder.nobatF2 / 100);

            this.state.data.record.bNobat = this.FixedPointNumber(totalNobat * ((percent * sumFog) / 7.33), 0);
        }

        this.state.data.record.bExtraWork = this.FixedPointNumber(this.state.data.record.extraTime * (((this.state.data.record.zExtraWork / 100) * sumFog) / 7.33), 0);
        this.state.data.record.bNight = this.FixedPointNumber(this.state.data.record.night * (((this.state.data.record.zNight / 100) * sumFog) / 7.33), 0);
        this.state.data.record.bHolyDay = this.FixedPointNumber(this.state.data.record.holyDay * (((this.state.data.record.zHoliday / 100) * sumFog) / 7.33), 0);
        this.state.data.record.bFriday = this.FixedPointNumber(this.state.data.record.friDay * (((this.state.data.record.zFriday / 100) * sumFog) / 7.33), 0);

    }
    updateFormula() {
        if (this.state.data.record.hour + this.state.data.record.leaveHour > this.state.data.record.monthHour)
            this.state.data.record.extraTime = this.FixedPointNumber(this.state.data.record.hour + this.state.data.record.leaveHour - this.state.data.record.monthHour, 2);
        else
            this.state.data.record.extraTime = 0;

        if ((this.state.data.record.hour + this.state.data.record.leaveHour - this.state.data.record.monthHour) >= 0)
            this.state.data.record.kamKariTime = 0;
        else
            this.state.data.record.kamKariTime = this.FixedPointNumber(this.state.data.record.hour + this.state.data.record.leaveHour - this.state.data.record.monthHour, 2);

        console.log(this.state.data.record);
        this.state.data.record.bMamoriyat = this.FixedPointNumber((((this.state.data.record.zMamoriyat / 100) * (this.state.data.record.masoliyat + this.state.data.record.jazb + this.state.data.record.bDaySalary2)) / 7.33) * this.state.data.record.mamoriyat, 0);
        console.log(this.state.data.record.bMamoriyat);

        this.state.data.record.bMonthBase = this.FixedPointNumber(this.state.data.record.bDaySalary * this.state.data.record.monthDays, 0);;
        this.state.data.record.bMonthBase2 = this.FixedPointNumber(this.state.data.record.bDaySalary2 * this.state.data.record.monthDays, 0);

        this.state.data.record.bHourSalary2 = this.FixedPointNumber((this.state.data.record.bKharobar + this.state.data.record.bMaskan + this.state.data.record.bMariage + this.state.data.record.bOlad + this.state.data.record.bMonthBase2) / this.state.data.record.monthHour, 0);

        this.state.data.record.total = this.FixedPointNumber(this.state.data.record.bMonthBase2 + this.state.data.record.bKharobar + this.state.data.record.bMaskan + this.state.data.record.bMariage
            + this.state.data.record.bOlad + this.state.data.record.bExtraWork + this.state.data.record.bNight + this.state.data.record.bHolyDay + this.state.data.record.bFriday + this.state.data.record.bNobat
            + this.state.data.record.jazb + this.state.data.record.masoliyat + this.state.data.record.bMamoriyat + this.state.data.record.travel, 0);

        this.state.data.record.totalWithInsu = this.FixedPointNumber(this.state.data.record.total - this.state.data.record.bOlad, 0);


        this.state.data.record.tamin1 = this.FixedPointNumber((this.state.data.record.totalWithInsu * 23) / 100, 0);

        this.state.data.record.tamin2 = this.FixedPointNumber((this.state.data.record.totalWithInsu * 30) / 100, 0);

        this.state.data.record.kosoratGeybat = this.FixedPointNumber((((this.state.data.record.bMonthBase2 + this.state.data.record.bKharobar + this.state.data.record.bMaskan + this.state.data.record.bMariage + this.state.data.record.bOlad + this.state.data.record.jazb + this.state.data.record.masoliyat) * this.state.data.record.kamKariTime) / this.state.data.record.monthHour), 0);
        if (this.state.data.record.kosoratGeybat > 0) this.state.data.record.kosoratGeybat = 0;

        this.state.data.record.kosoratTamin = this.FixedPointNumber(((this.state.data.record.tamin1 * this.state.data.record.kamKariTime) / this.state.data.record.monthHour), 0);
        if (this.state.data.record.kosoratTamin > 0) this.state.data.record.kosoratTamin = 0;

        this.state.data.record.kosoratBime = this.FixedPointNumber((this.state.data.record.totalWithInsu * 7) / 100, 0);

        this.state.data.record.kosoratMoafiyat = this.FixedPointNumber((this.state.data.record.kosoratBime * 2) / 7, 0);

        //چون بر اساس 30 روز همیشه حساب میشه برای همینه حقوق پایه ماهیانه رو دستی سی روز حساب میکنم. بقیه آیتم ها تو همه ماهها یکی هست

        var rewardBMonthBase2 = this.state.data.record.bDaySalary * 30;
        if (this.state.data.company.inReward.includes("[1]")) rewardBMonthBase2 += this.state.data.record.bMonthBase;
        if (this.state.data.company.inReward.includes("[2]")) rewardBMonthBase2 += this.state.data.record.bMonthBase2;
        if (this.state.data.company.inReward.includes("[3]")) rewardBMonthBase2 += this.state.data.record.bKharobar;
        if (this.state.data.company.inReward.includes("[4]")) rewardBMonthBase2 += this.state.data.record.bMaskan;
        if (this.state.data.company.inReward.includes("[14]")) rewardBMonthBase2 += this.state.data.record.bMariage;
        if (this.state.data.company.inReward.includes("[5]")) rewardBMonthBase2 += this.state.data.record.bOlad;
        if (this.state.data.company.inReward.includes("[6]")) rewardBMonthBase2 += this.state.data.record.bExtraWork;
        if (this.state.data.company.inReward.includes("[7]")) rewardBMonthBase2 += this.state.data.record.bNight;
        if (this.state.data.company.inReward.includes("[8]")) rewardBMonthBase2 += this.state.data.record.bHolyDay;
        if (this.state.data.company.inReward.includes("[9]")) rewardBMonthBase2 += this.state.data.record.bFriday;
        if (this.state.data.company.inReward.includes("[10]")) rewardBMonthBase2 += this.state.data.record.bno;
        if (this.state.data.company.inReward.includes("[11]")) rewardBMonthBase2 += this.state.data.record.jazb;
        if (this.state.data.company.inReward.includes("[12]")) rewardBMonthBase2 += this.state.data.record.masoliyat;
        if (this.state.data.company.inReward.includes("[13]")) rewardBMonthBase2 += this.state.data.record.bMamoriyat;

        this.state.data.record.reward = this.FixedPointNumber(rewardBMonthBase2 * 3, 0);
        var maxReward = this.state.data.record.bDaySalary * 90;
        if (maxReward < this.state.data.record.reward) this.state.data.record.reward = maxReward;

        this.state.data.record.totalWithTax = this.FixedPointNumber(this.state.data.record.total - this.state.data.record.kosoratMoafiyat, 0)

        this.state.data.record.maliyatMah = this.FixedPointNumber((this.state.data.record.totalWithTax - this.state.data.record.moafiyatMah) * 10 / 100);

        this.state.data.record.hogogMashmolMaliyatTajmiyi = this.FixedPointNumber(this.state.data.record.totalWithTax + this.preMonthTax(this.state.data.record.month, this.state.data.record.year), 0);

        this.state.data.record.moafiyatTajmiyiMah = this.FixedPointNumber(this.moafiyatTajmiyiMah(this.state.data.record.month), 0);

        this.state.data.record.maliyatMahTajmiyi = this.FixedPointNumber((this.state.data.record.hogogMashmolMaliyatTajmiyi - this.state.data.record.moafiyatTajmiyiMah) * 10 / 100);

        this.state.data.record.kosoratTax = this.FixedPointNumber(this.finalTaxKosorat(this.state.data.record.maliyatMahTajmiyi, this.state.data.record.month, this.state.data.record.year), 0);
        if (this.state.data.record.kosoratTax < 0) this.state.data.record.kosoratTax = 0;

        this.state.data.record.orgDeductions = this.FixedPointNumber(this.state.data.record.kosoratMosaede + this.state.data.record.kosoratVam + this.state.data.record.kosoratOther - this.state.data.record.kosoratGeybat - this.state.data.record.kosoratTamin, 0);

        this.state.data.record.legalDeductions = this.FixedPointNumber(this.state.data.record.kosoratBime + this.state.data.record.kosoratTax, 0);

        this.state.data.record.final = this.FixedPointNumber((this.state.data.record.total - this.state.data.record.orgDeductions - this.state.data.record.legalDeductions), 0);
    }
    preMonthTax(month, year) {
        if (month === 1) return 0;
        var s = 0;
        this.state.data.histories.forEach(h => {
            if (h.year == year && h.month == month) s = h.hogogMashmolMaliyatTajmiyi;
        });
        return s;
    }
    moafiyatTajmiyiMah(month) {
        var p = 0;
        this.state.data.salaryBases.forEach(b => {
            if (b.year === this.state.data.record.year) p = b.maxTax;
        });

        var dayCount = 1;

        if (month === 1) dayCount = 31;
        if (month === 2) dayCount = 62;
        if (month === 3) dayCount = 93;
        if (month === 4) dayCount = 124;
        if (month === 5) dayCount = 155;
        if (month === 6) dayCount = 186;
        if (month === 7) dayCount = 216;
        if (month === 8) dayCount = 246;
        if (month === 9) dayCount = 276;
        if (month === 10) dayCount = 306;
        if (month === 11) dayCount = 336;
        if (month === 12) dayCount = 365;

        return (p / 365) * dayCount;
    }
    finalTaxKosorat(maliyatTajmiyiMah, month, year) {
        var s = maliyatTajmiyiMah;

        this.state.data.histories.forEach(h => {
            if (h.year == year && h.month < month) s = s - h.kosoratTax;
        });

        return s;
    }
    getYearList() {
        var list = [];
        for (var i = this.state.data.currentShamsiYear; i >= this.state.data.currentShamsiYear - 30; i--) list.push(i);
        return list;
    }
    renderForm() {
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">

                            <div className="nk-block-head">
                                <div className="nk-block-between g-3">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">صدور فیش حقوقی</h3>
                                    </div>
                                    <div className="nk-block-head-content">
                                        <NavLink to="/payslips/" className="btn btn-outline-light bg-white d-none d-sm-inline-flex"><em className="icon ni ni-arrow-left"></em><span>برگشت</span></NavLink>
                                        <NavLink to="/payslips" className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"><em className="icon ni ni-arrow-left"></em></NavLink>
                                        {this.state.data.record.id !== this.defaultGuid() && <NavLink to={"/payslip/preview/" + this.state.data.record.id + "/"} className="btn btn-white btn-outline-light"><em class="icon ni ni-eye"></em><span>پیش نمایش و ارسال</span></NavLink>}
                                        {this.state.data.record.id !== this.defaultGuid() && <a onClick={e => this.getPdf(e)} className="btn btn-white btn-outline-light"><em class="icon ni ni-file-pdf"></em><span>خروجی PDF</span></a>}
                                    </div>
                                </div>
                            </div>
                            <div className="nk-block nk-block-lg">
                                <form method="post" onSubmit={e => this.save(e)} className="row g-gs">
                                    <div className="col-lg-12">
                                        <div className="card card-bordered h-100">
                                            <div className="card-inner">
                                                <div className="row g-4">
                                                    <div className="col-lg-8">
                                                        <div className="form-group">
                                                            <label className="form-label">کارمند</label>
                                                            <div className="form-control-wrap">
                                                                <SelectAsync
                                                                    defaultValue={this.state.data.record.manCompanyId !== this.defaultGuid() ? [{ value: this.state.data.record.manCompanyId, label: this.state.data.record.manCompanyFName + " " + this.state.data.record.manCompanyLName + "(" + this.state.data.record.manCompanyNationalId + ")" }] : null}
                                                                    isMulti={false}
                                                                    placeholder="انتخاب کارمند"
                                                                    defaultOptions
                                                                    loadOptions={this.loadManCompaniesOptions}
                                                                    onChange={e => this.itemChange('manCompanyId', e)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-2">
                                                        <div className="form-group">
                                                            <label className="form-label">سال</label>
                                                            <div className="form-control-wrap">
                                                                <select className="form-control text-center" type="text" defaultValue={this.state.data.record.year} onChange={e => this.itemChange('year', e.target.value)}>
                                                                    {this.getYearList().map(p => <option value={p}>{p}</option>)}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-2">
                                                        <div className="form-group">
                                                            <label className="form-label">ماه</label>
                                                            <div className="form-control-wrap">
                                                                <select className="form-control text-center" type="text" defaultValue={this.state.data.record.month} onChange={e => this.itemChange('month', e.target.value)}>
                                                                    <option value="1">فروردین</option>
                                                                    <option value="2">اردیبهشت</option>
                                                                    <option value="3">خرداد</option>
                                                                    <option value="4">تیر</option>
                                                                    <option value="5">مرداد</option>
                                                                    <option value="6">شهریور</option>
                                                                    <option value="7">مهر</option>
                                                                    <option value="8">آبان</option>
                                                                    <option value="9">آذر</option>
                                                                    <option value="10">دی</option>
                                                                    <option value="11">بهمن</option>
                                                                    <option value="12">اسفند</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-8">
                                                        <div className="form-group">
                                                            <label className="form-label">حکم کارگزینی</label>
                                                            <div className="form-control-wrap">
                                                                <select key={this.state.data.record.year} className="form-control text-center" type="text" defaultValue={this.state.data.record.employmentOrderId} onChange={e => this.itemChange('employmentOrderId', e.target.value)}>
                                                                    <option value={this.getDefaultGuid()}>انتخاب کنید</option>
                                                                    {this.state.employmentOrders.map(em =>
                                                                        em.dueYear === this.state.data.record.year && <option value={em.id}>اجرایی {em.dueDate} مربوط به قرارداد شماره {em.contractNumber} با موضوع {em.contractSubject}</option>
                                                                    )}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-2">
                                                        <div className="form-group">
                                                            <label className="form-label">تایم شیت</label>
                                                            <div className="form-control-wrap">
                                                                <select key={this.state.data.record.contractId} className="form-control text-center" type="text" defaultValue={this.state.data.record.timeSheetHeaderId} onChange={e => this.itemChange('timeSheetHeaderId', e.target.value)}>
                                                                    <option value={this.getDefaultGuid()}>انتخاب کنید</option>
                                                                    {this.state.timeSheetHeaders.map(tm =>
                                                                        tm.contractId == this.state.data.record.contractId && <option value={tm.id}>{tm.year}/{tm.month}</option>
                                                                    )}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-2">
                                                        <div className="form-group">
                                                            <label className="form-label"></label>
                                                            <div className="form-control-wrap">
                                                                <button type="submit" className="btn btn-lg btn-primary">ذخیره</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.data.record.timeSheetHeaderId != this.getDefaultGuid() && <div className="col-lg-12">
                                        <div className="card card-bordered h-100">
                                            <div className="card-inner">
                                                <div className="card-head">
                                                    <h5 className="card-title">اطلاعات آماری</h5>
                                                </div>
                                                <div className="row g-4">
                                                    <div className="col-lg-4">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <label className="form-label">مرخصی تایید شده به روز</label>
                                                                <div className="form-control-wrap">
                                                                    <NumberFormat value={this.state.data.record.leaveDay} onChange={e => this.itemChange('leaveDay', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <label className="form-label">مرخصی تایید شده به ساعت</label>
                                                                <div className="form-control-wrap">
                                                                    <NumberFormat value={this.state.data.record.leaveHour} onChange={e => this.itemChange('leaveHour', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <label className="form-label">کارکرد به روز</label>
                                                                <div className="form-control-wrap">
                                                                    <NumberFormat style={{ backgroundColor: "#F44336", color: "white" }} value={this.state.data.record.day} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <label className="form-label">کارکرد به ساعت</label>
                                                                <div className="form-control-wrap">
                                                                    <NumberFormat style={{ backgroundColor: "#F44336", color: "white" }} value={this.state.data.record.hour} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <label className="form-label">ساعات اضافه کاری</label>
                                                                <div className="form-control-wrap">
                                                                    <NumberFormat value={this.state.data.record.extraTime} readOnly thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <label className="form-label">ساعات کم کاری</label>
                                                                <div className="form-control-wrap">
                                                                    <NumberFormat value={this.state.data.record.kamKariTime} readOnly thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <label className="form-label">ساعات شب کاری</label>
                                                                <div className="form-control-wrap">
                                                                    <NumberFormat value={this.state.data.record.night} onChange={e => this.itemChange('night', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <label className="form-label">روزهای تعطیل کاری</label>
                                                                <div className="form-control-wrap">
                                                                    <NumberFormat value={this.state.data.record.holyDay} onChange={e => this.itemChange('holyDay', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <label className="form-label">روزهای جمعه کاری</label>
                                                                <div className="form-control-wrap">
                                                                    <NumberFormat value={this.state.data.record.friDay} onChange={e => this.itemChange('friDay', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <label className="form-label">ساعت ماموریت</label>
                                                                <div className="form-control-wrap">
                                                                    <NumberFormat value={this.state.data.record.mamoriyat} onChange={e => this.itemChange('mamoriyat', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <label className="form-label">وام کارکنان </label>
                                                                <div className="form-control-wrap">
                                                                    <NumberFormat value={this.state.data.record.vam} onChange={e => this.itemChange('vam', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <label className="form-label">سایر اقساط</label>
                                                                <div className="form-control-wrap">
                                                                    <NumberFormat value={this.state.data.record.other} onChange={e => this.itemChange('other', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <label className="form-label">مساعده </label>
                                                                <div className="form-control-wrap">
                                                                    <NumberFormat value={this.state.data.record.mosaede} onChange={e => this.itemChange('mosaede', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <label className="form-label">ساعت موظف این ماه </label>
                                                                <div className="form-control-wrap">
                                                                    <NumberFormat style={{ backgroundColor: "#9E9E9E" }} readOnly={true} value={this.state.data.record.monthHour} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <label className="form-label">حق مرخصی ماهانه به ساعت</label>
                                                                <div className="form-control-wrap">
                                                                    <NumberFormat readOnly={true} value={this.state.data.record.monthLeave} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <label className="form-label">حق مرخصی ماهانه به روز</label>
                                                                <div className="form-control-wrap">
                                                                    <NumberFormat readOnly={true} value={this.state.data.record.monthLeaveDay} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                                    {this.state.data.record.timeSheetHeaderId != this.getDefaultGuid() && <div className="col-lg-4">
                                        <div className="card card-bordered h-100">
                                            <div className="card-inner">
                                                <div className="card-head">
                                                    <h5 className="card-title">محاسبه حقوق و دستمزد</h5>
                                                </div>
                                                <div className="row g-4">
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">حقوق پایه بر اساس سابقه در حکم پرسنلی </label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.bMonthBase2} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">حق خواروبار</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.bKharobar} onChange={e => this.itemChange('bKharobar', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">حق مسکن</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.bMaskan} onChange={e => this.itemChange('bMaskan', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">حق تاهل</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.bMariage} onChange={e => this.itemChange('bMariage', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>                                                    
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">حق اولاد</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.bOlad} onChange={e => this.itemChange('bOlad', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">فوق العاده اضافه کاری</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.bExtraWork} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">فوق العاده شب کاری</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.bNight} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">فوق العاده جمعه کاری </label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.bFriday} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">فوق العاده تعطیل کاری</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.bHolyDay} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">فوق العاده نوبت کاری</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.bNobat} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label"> فوق العاده ماموریت</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.bMamoriyat} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">سایر فوق العاده ها</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.travel} onChange={e => this.itemChange('travel', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                                    {this.state.data.record.timeSheetHeaderId != this.getDefaultGuid() && <div className="col-lg-4">
                                        <div className="card card-bordered h-100">
                                            <div className="card-inner">
                                                <div className="card-head">
                                                    <h5 className="card-title">کسورات</h5>
                                                </div>
                                                <div className="row g-4">
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">مساعده</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.kosoratMosaede} onChange={e => this.itemChange('kosoratMosaede', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">وام کارکنان</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.kosoratVam} onChange={e => this.itemChange('kosoratVam', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">سایر اقساط</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.kosoratOther} onChange={e => this.itemChange('kosoratOther', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">کم کاری و غیبت</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat readOnly={true} style={{ backgroundColor: "#9E9E9E" }} value={this.state.data.record.kosoratGeybat} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">کسری بیمه تامین اجتماعی</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat readOnly={true} style={{ backgroundColor: "#9E9E9E" }} value={this.state.data.record.kosoratTamin} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">حق بیمه</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat readOnly={true} style={{ backgroundColor: "#9E9E9E" }} value={this.state.data.record.kosoratBime} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">معافیت 2.7 یا 7.7</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat readOnly={true} style={{ backgroundColor: "#9E9E9E" }} value={this.state.data.record.kosoratMoafiyat} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">مجموع کسورات سازمانی</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.orgDeductions} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">جمع کسورات قانونی</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.legalDeductions} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                                    {this.state.data.record.timeSheetHeaderId != this.getDefaultGuid() && <div className="col-lg-4">
                                        <div className="card card-bordered h-100">
                                            <div className="card-inner">
                                                <div className="card-head">
                                                    <h5 className="card-title">جمع نهایی</h5>
                                                </div>
                                                <div className="row g-4">
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">حقوق مشمول و غیر مشمول</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.total} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">حقوق مشمول مالیات</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.totalWithTax} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">حقوق مشمول بیمه</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.totalWithInsu} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">حقوق پرداختی</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.final} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">23%بیمه تامین اجتماعی</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.tamin1} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">30%بیمه تامین اجتماعی</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.tamin2} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}